import React from 'react';
import { useFetchCategories, useFetchFAQ } from '../../hooks/chat/chat';

const HrTopicsAndFaqs: React.FC = () => {
  // const user_id="99472f4d-bf99-4804-8455-36a515979678"
  const user_id=2
  const categories= useFetchCategories(user_id)
  const [activeCategoryId, setActiveCategoryId] = React.useState(1);

  const faq= useFetchFAQ(activeCategoryId)
  const handleTopicClick = (id: number) => {
    // Handle topic click logic here (e.g., navigation, API call)
    console.log('Topic clicked:', id);
    setActiveCategoryId(id);
  };

    const handleFaqClick = (faq: string) => {
        // Handle FAQ click logic here (e.g., navigation, API call)
        console.log('FAQ clicked:', faq);
    };

  return (
    <div className="bg-gray-100 p-6 font-sans"> {/* Added background color and padding */}
      {/* Quick HR Topics */}
      <div className="mb-8"> {/* Added margin bottom */}
        <h2 className="text-xl font-bold text-gray-800 mb-4">Quick HR Topics</h2> {/* Improved heading style */}
        <div className="grid grid-cols-2 gap-4"> {/* Use grid for layout */}
          {categories.data?.map(category=><button
            onClick={() => handleTopicClick(category.id)}
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-300 transition duration-300"
          >
            {category.category_name}
          </button>)}
          {/* <button
            onClick={() => handleTopicClick('Benefits')}
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-300 transition duration-300"
          >
            Benefits
          </button>
          <button
            onClick={() => handleTopicClick('Payroll')}
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-300 transition duration-300"
          >
            Payroll
          </button>
          <button
            onClick={() => handleTopicClick('Training')}
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-300 transition duration-300"
          >
            Training
          </button>
          <button
            onClick={() => handleTopicClick('Attendance')}
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-300 transition duration-300"
          >
            Attendance
          </button>
          <button
            onClick={() => handleTopicClick('See More')}
            className="border border-orange-500 hover:bg-blue-500 hover:text-white text-orange-500 font-bold py-3 px-6 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-300 transition duration-300"
          >
            See More
          </button> */}
        </div>
      </div>

      {/* Frequently Asked Questions */}
      <div>
       
        <h2 className="text-xl font-bold text-gray-800 my-4">Frequently Asked Questions</h2> {/* Improved heading style */}
       
        <div className="bg-white join join-vertical w-full">

        {faq.isLoading?  <div className="loading"></div>:null}
 {faq.data?.map(item=> <div className=" bg-white collapse collapse-arrow join-item border-base-300 border">
    <input type="radio" name="my-accordion-4"  />
    <div className="collapse-title text-xl font-medium">{item.text}</div>
    <div className="collapse-content">
      <p>{item.answer}</p>
    </div>
  </div>)}
 


</div>
       
       
       
    
      </div>
    </div>
  );
};

export default HrTopicsAndFaqs;